/* istanbul ignore file */
import { AnalyticsConfig } from '../actions/analyticsConfig'
import { STORE_ANALYTICS_CONFIG } from '../constants/actionTypes'

const initialState = {}

const analyticsConfigReducer = (
  state = initialState,
  action: { type: string; analyticsConfig: AnalyticsConfig }
) => {
  switch (action.type) {
    case STORE_ANALYTICS_CONFIG:
      return Object.assign({}, state, action.analyticsConfig)
    default:
      return state
  }
}

export default analyticsConfigReducer
export { initialState }
